// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__1XOaH","ThumbZoom":"ChapterPlayer_ThumbZoom__2_4mL"};